<template>
  <div class="animated fadeIn list-of-coa">
    <b-card>
      <div slot="header">
        Chart of Account
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="refreshSaldo()"><i class="fa fa-refresh"></i> Refresh Balance</button>
          <!-- <button class="btn btn-primary mr-1" @click="refreshStruktur()"><i class="fa fa-refresh"></i> Refresh Structure/tree</button> -->
          <b-button variant="btn btn-primary mr-1" @click="print">Print</b-button>
          <b-button variant="btn btn-primary mr-1" @click="exportXls">Export</b-button>
          <b-button variant="btn btn-primary" @click="close">Close</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="2">
          <b-input-group>
            <b-input-group-prepend><label>Year of</label></b-input-group-prepend>
            <b-form-select v-model="tblData.tahun" :plain="true" :options="tahunBuku"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="8">
          <b-input-group>
            <b-input-group-prepend><label>Account Code</label></b-input-group-prepend>
            <b-form-input v-model="tblData.kodeacc"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">Name</span></b-input-group-prepend>
            <b-form-input v-model="tblData.namaacc" style="width: 35% !important"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="refresh()"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="data"
        :fields="tblData.fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @filtered="onFiltered"
      >
        <template v-slot:cell(namahtml)="data">
          <div v-if="data.item.tanda_nrc == '8' || data.item.tanda_nrc == '9'">
            <span v-if="data.item.tanda_nrc == '8'" v-html="data.item.accname" style="background-color: #428bca"></span>
            <span v-else v-html="data.item.accname" style="background-color: #5bc0de"></span>
          </div>
          <div v-else>
            <span v-if="data.item.judul == 'Y'" v-html="data.item.accname" style="font-weight: bold"></span>
            <span v-else v-html="data.item.accname"></span>
          </div>
        </template>
        <template v-slot:cell(awal)="data">
          <span v-if="data.item.judul == 'Y'" style="font-weight: bold">{{ data.item.awal | numFormat("0,0.00") }}</span>
          <span v-else>{{ data.item.awal | numFormat("0,0.00") }}</span>
        </template>
        <template v-slot:cell(debet)="data">
          <span v-if="data.item.judul == 'Y'" style="font-weight: bold">{{ data.item.debet | numFormat("0,0.00") }}</span>
          <span v-else>{{ data.item.debet | numFormat("0,0.00") }}</span>
        </template>
        <template v-slot:cell(kredit)="data">
          <span v-if="data.item.judul == 'Y'" style="font-weight: bold">{{ data.item.kredit | numFormat("0,0.00") }}</span>
          <span v-else>{{ data.item.kredit | numFormat("0,0.00") }}</span>
        </template>
        <template v-slot:cell(akhir)="data">
          <span v-if="data.item.judul == 'Y'" style="font-weight: bold">{{ data.item.akhir | numFormat("0,0.00") }}</span>
          <span v-else>{{ data.item.akhir | numFormat("0,0.00") }}</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="3">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to <span v-if="tblData.page * tblData.limit > tblData.total">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="2">
          <b-row class="ml-2">
            <span class="pt-1 pr-2">Limit per page</span>
            <input type="number" style="width: 80px" v-model="limit" />
          </b-row>
        </b-col>
        <b-col cols="7">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showForm" header-bg-variant="primary" size="xl" :title="formTitle" :centered="true" @ok="handleOk">
        <b-row>
          <b-col cols="6">
            <b-form-group label-cols="3" label="Year of">
              <b-form-input type="number" v-model="model.tahun" id="inputTahunBukufrm" aria-describedby="inputTahunBukufrmFeedback" :state="$v.model.tahun.required"></b-form-input>
              <b-form-invalid-feedback id="inputTahunBukufrmFeedback"> Field is required </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols="3" label="Account Code">
              <b-form-input v-model="model.kodeacc" id="inputKodeacc" aria-describedby="inputKodeaccFeedback" :state="$v.model.kodeacc.required"></b-form-input>
              <b-form-invalid-feedback id="inputKodeaccFeedback"> Field is required </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label-cols="3" label="Account Name">
              <b-form-input v-model="model.namaacc" id="inputNamaacc" aria-describedby="inputNamaaccFeedback" :state="$v.model.namaacc.required"></b-form-input>
              <b-form-invalid-feedback id="inputNamaaccFeedback"> Field is required </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols="3" label="Account Type">
              <b-form-select v-model="model.typeacc" :plain="true" :options="accountType" :state="$v.model.typeacc.required"></b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" label=" Account Flag">
              <b-form-select v-model="model.tanda_nrc" :plain="true" :options="accountFlag"></b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" label="Begining Balance">
              <!-- <v-number class="form-control text-right" separator="," :minus="true" v-model="model.awal"></v-number> -->
              <my-number v-model="model.awal" class="form-control text-right" :minus="true" separator="," :precision="2"></my-number>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <h5>Default Dimmension</h5>
            <v-dim :model="model" :key="model.kodeacc"></v-dim>
          </b-col>
        </b-row>
        <!-- <b-form @submit.stop.prevent="save"> -->
        <!-- </b-form> -->
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Print Chart Of Account">
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-coa {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .input-group {
    .input-group-prepend {
      label {
        width: 110px !important;
      }
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import coa from "../../apis/coa";
import vDim from "../lookup/dim";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required, maxLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      tahun: { required },
      kodeacc: {
        required,
        maxLength: maxLength(50),
      },
      namaacc: {
        required,
        maxLength: maxLength(100),
      },
      typeacc: { required },
    },
  },
  components: { Loading, vDim, myNumber },
  data() {
    return {
      accountType: [
        { value: "DEBIT", text: "DEBIT" },
        { value: "CREDIT", text: "CREDIT" },
      ],
      accountFlag: [
        { value: "0", text: "Normal Account" },
        { value: "1", text: "First Level of ASSET" },
        { value: "2", text: "First Level of LIABILITIES" },
        { value: "3", text: "First Level of EQUITY" },
        { value: "8", text: "Retain Earning" },
        { value: "9", text: "Profit/(Loss) Current Year" },
      ],
      formTitle: "Add - Chart of Account",
      saveEnabled: true,
      showForm: false,
      showReport: false,
      showDelConfirm: false,
      isLoading: false,
      horizontal: true,
      model: {
        tahun: "",
        kodeacc: "",
        namaacc: "",
        typeacc: "",
        awal: 0,
      },
      tblData: {
        items: [],
        fields: [
          {
            key: "tahun",
            thStyle: "width:100px",
            label: "Year",
          },
          {
            key: "kodeacc",
            label: "Account Code",
            thStyle: "width:200px",
            sortable: true,
          },
          {
            key: "namahtml",
            label: "Account Name",
          },
          {
            key: "typeacc",
            thStyle: "width:100px",
            label: "Type",
          },
          {
            key: "awal",
            label: "Begining Blc.",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "debet",
            label: "Debit",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "kredit",
            label: "Credit",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "akhir",
            label: "Ending Blc.",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "action",
            label: "Action",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 15,
        total: 0,

        sortBy: null,
        sortDesc: false,
        kodeacc: "",
        namaacc: "",
        tahun: new Date().getFullYear(),
        tahunBukuFrm: [],
      },
      limit: 15,
      user: this.$store.state.user,
      tahunBuku: [],
      reportUrl: null,
    };
  },
  created: async function () {
    this.tahunBuku = await coa.tahunbuku();
    this.tahunBukuFrm = this.tahunBuku.reduce(
      (newArr, item) => {
        newArr.push(item);
        return newArr;
      },
      [{ value: moment().format("YYYY"), text: moment().format("YYYY") }],
    );

    if (parseInt(this.user.tglaktif.substr(0, 4)) + 1 == parseInt(moment().format("YYYY")) && moment().format("MM") >= "10") {
      this.tahunBuku = this.tahunBukuFrm;
    }
  },
  computed: {
    filterKode() {
      return this.tblData.kodeacc;
    },
    filterNama() {
      return this.tblData.namaacc;
    },
    isValid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
  },
  watch: {
    limit: function (newVal) {
      setTimeout(() => {
        if (this.limit == newVal) {
          this.tblData.limit = newVal;
        }
      }, 500);
    },
    filterKode: function (kodeacc) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (kodeacc == tblData.kodeacc) refresh();
      }, 500);
    },
    filterNama: function (namaacc) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (namaacc == tblData.namaacc) refresh();
      }, 500);
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await coa.list(this.tblData);
      this.tblData.refreshsaldo = "";
      return list;
    },
    add: function () {
      this.model = { kodeacc: "", namaacc: "", tahun: parseInt(this.user.tglaktif.substr(0, 4)) };
      this.formTitle = "Add - Chart of Account";
      this.showForm = true;
    },
    edit: function (data) {
      for (var key in this.model) {
        this.model[key] = "";
      }
      for (var key in data) {
        if (data[key]) this.model[key] = data[key];
      }
      this.model.kodelama = data.kodeacc;
      this.model.tahunlama = data.tahun;
      this.formTitle = "Edit - Chart of Account";
      this.showForm = true;
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    handleOk: function (evt) {
      const { model, isValid } = this;
      // console.log('isValid : ', isValid)
      evt.preventDefault();
      if (!isValid) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.save();
      }
    },
    save: async function () {
      if (!this.saveEnabled) {
        return;
      }
      this.saveEnabled = false;
      const { model, isValid } = this;
      if (isValid == true) {
        try {
          this.isLoading = true;
          if (this.formTitle == "Add - Chart of Account") {
            await coa.insert(model);
          } else {
            await coa.update(model);
          }
          this.isLoading = false;
          this.saveEnabled = true;
          this.showForm = false;
          this.refresh();
        } catch (error) {
          console.log("save : ", error);
          this.isLoading = false;
          this.saveEnabled = true;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    deleteData: async function () {
      try {
        this.isLoading = true;
        await coa.remove(this.model);
        this.isLoading = false;
        this.refresh();
      } catch (error) {
        this.isLoading = false;
        console.log("delete coa : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    print: async function () {
      try {
        this.reportUrl = null; this.showReport = true;
        this.reportUrl = await coa.print(this.tblData);
      } catch (error) {
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    // exportXls: function() {
    //   const obj = {tahun: this.tblData.tahun , kodeacc: this.tblData.kodeacc, namaacc: this.tblData.namaacc };
    //   coa.exportXls(obj);
    // },
    exportXls: async function () {
      try {
        this.isLoading = true;
        const obj = { tahun: this.tblData.tahun, kodeacc: this.tblData.kodeacc, namaacc: this.tblData.namaacc };
        const response = await coa.exportXls(obj);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "coa.xlsx");
        document.body.appendChild(link);
        link.click();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    refresh() {
      this.$refs.table.refresh();
    },
    refreshSaldo() {
      this.tblData.refreshsaldo = "1";
      this.$refs.table.refresh();
    },
    async refreshStruktur() {
      await coa.refreshStruktur({ tahunBuku: this.tblData.tahunBuku });
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.refreshsaldo = "";
      this.tblData.kodeacc = "";
      this.tblData.namaacc = "";
    },
    close() {
      router.push("home");
    },
  },
};
</script>
